import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

import { Subject, Observable } from 'rxjs/Rx';
import { interval } from 'rxjs/observable/interval';

import { ClientReportService } from '../client-report/client-report.service';

@Injectable()
export class PollingService {
  //ポーリング用変数
  subject = new Subject<any>();
  data$ = this.subject.asObservable();
  //制御端末コード
  private printagentCd = '';

  constructor(
      private http: HttpService,
      private clientReportService: ClientReportService
    ) { 

    if (localStorage.getItem(`printagentCd`) !== null) {
        this.printagentCd = localStorage.getItem(`printagentCd`);
    }
  }

  polling(
    printagentCd: string,
    targetReportCdList: string[]
  ): Observable<any> {
    return interval(1000).flatMap(() => 
    this.clientReportService.checkPrintQueue(printagentCd, targetReportCdList, "wa3051")
    )
    .takeWhile(() => true);
  }  

}


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/polling/polling.service.ts